import { useState, useEffect } from "react";
import { Bell, BellRing } from "lucide-react";
import { pushSupported, enablePush } from "@/lib/push";
import { toast } from "sonner";

export default function PushButton({ className = "", dark = false }) {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (pushSupported() && Notification.permission === "granted") {
      navigator.serviceWorker.ready
        .then((r) => r.pushManager.getSubscription())
        .then((s) => setOn(!!s))
        .catch(() => {});
    }
  }, []);

  if (!pushSupported()) return null;

  const toggle = async () => {
    setBusy(true);
    try { await enablePush(); setOn(true); toast.success("Notifications activées"); }
    catch (e) { toast.error(e.message || "Activation impossible"); }
    finally { setBusy(false); }
  };

  const base = on
    ? (dark ? "bg-white/10 text-green-300" : "bg-green-50 text-green-700 border border-green-200")
    : (dark ? "bg-white/15 text-white hover:bg-white/25" : "border border-slate-200 text-slate-700 hover:border-[#C85A32]/50");

  return (
    <button onClick={toggle} disabled={busy || on} data-testid="push-enable-btn"
      className={`${className} inline-flex items-center gap-2 text-sm font-semibold px-4 py-2 rounded-lg transition disabled:opacity-70`}>
      {on ? <BellRing className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
      {on ? "Notifications activées" : (busy ? "Activation…" : "Activer les notifications")}
    </button>
  );
}
